import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../../common/helpers/common.utils.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const NavTab = forwardRef((props, ref) => {
  const { items, className, role = "navigation", ...rest } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...rest,
      ref,
      role,
      className: twMerge("flex items-center overflow-x-auto hide-scrollbar gap-6", className),
      children: items.map((itemProps, i) => {
        const { content, isActive, className: itemClassName, ...itemRest } = itemProps;
        return /* @__PURE__ */ jsxs(
          "div",
          {
            ...itemRest,
            className: cn(
              "relative inline-flex items-center justify-center text-center h-full gap-2 py-3 text-sm whitespace-nowrap font-medium text-grayscale-500 cursor-pointer",
              isActive && "text-primary",
              itemClassName
            ),
            children: [
              content,
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: [
                    "absolute bottom-0 h-[2px] bg-primary rounded-md transition-all duration-200",
                    isActive ? "w-full opacity-1" : "w-0 opacity-0"
                  ].join(" ")
                }
              )
            ]
          },
          i
        );
      })
    }
  );
});
export {
  NavTab as default
};
//# sourceMappingURL=NavTab.js.map
